import React from 'react';
import { pageHeroPhotos } from '../data/pageHeroPhotos';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { PageHeading } from '../components/PageHeading';
import { TrustLocalBand } from '../components/TrustLocalBand';
import { business, financingProviders } from '../data/site';
import { usePageMeta } from '../hooks/usePageMeta';
export function Financing() {
  usePageMeta('Auto Repair Financing in Oak Ridge, TN | East End Automotive Repair', 'Ask The East End Team about payment options for your repair. East End Automotive Repair in Oak Ridge, TN offers Snap Finance, Affirm, Klarna, and Sunbit. Call (865) 206-2279.');
  return <>
      <PageHeading photo={{
      ...pageHeroPhotos.financing,
      position: 'center 48%',
      mobilePosition: '72% 50%'
    }} eyebrow="Payment options" title="Financing for Your Repair" intro="Ask The East End Team about payment options for your repair. We offer Snap Finance, Affirm, Klarna, and Sunbit." data-id="element-563" data-mp="3ky6ipuc1c3el" />

      <section className="w-full bg-white py-14 lg:py-20" data-id="element-564" data-mp="3tpn66qr8eshg">
        <div className="mx-auto max-w-shell min-w-0 px-5 lg:px-8" data-id="element-565" data-mp="3tp3nh7trc02d">
          <h2 className="font-display text-[24px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[30px]" data-id="element-566" data-mp="chrrkkab0cta">
            Providers we offer
          </h2>
          <p className="mt-4 max-w-[620px] text-[16px] leading-relaxed text-steel/75" data-id="element-567" data-mp="3fy89xi8bcusg">
            Each provider runs its own program. The links below go to that
            provider’s own information page so you can read how it works before
            you call.
          </p>

          <ul className="mt-9 grid grid-cols-[minmax(0,1fr)] gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-568" data-mp="3pq4l9uzeuhem">
            {financingProviders.map(provider => <li key={provider.name} className="flex min-w-0 flex-col overflow-hidden rounded-lg border border-black/10 bg-white" data-id="element-569" data-mp="2x6xld7q28u3q">
                <div className="flex h-[112px] items-center justify-center bg-white px-6 py-5" data-id="element-570" data-mp="3hx1gngz1e54g">
                  <img src={provider.logo} alt={`${provider.name} logo`} loading="lazy" className="max-h-full max-w-full object-contain" data-id="element-571" data-mp="3ly50sfo4anbh" />
                </div>
                <div className="flex flex-1 flex-col border-t border-black/10 bg-chalk px-5 py-5" data-id="element-572" data-mp="3vnepdljr5nuu">
                  <h3 className="font-display text-[17px] font-bold tracking-tight text-ink" data-id="element-573" data-mp="2yzqiy0t1zjr4">
                    {provider.name}
                  </h3>
                  <a href={provider.learnUrl} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[13.5px] font-bold text-brand-dark hover:underline" data-id="element-574" data-mp="37y2hqq42pnun">
                    Learn about {provider.name}
                    <ArrowUpRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-575" data-mp="s9kekn8mvldw" />
                  </a>
                </div>
              </li>)}
          </ul>

          <p className="mt-8 max-w-[680px] text-[14px] leading-relaxed text-steel/60" data-id="element-576" data-mp="22z70jjz8l5gc">
            Financing availability and terms vary by provider. Ask the shop for
            details.
          </p>
        </div>
      </section>

      <section className="w-full bg-chalk py-14 lg:py-18" data-id="element-577" data-mp="1tzsb8nut30xf">
        <div className="mx-auto max-w-shell min-w-0 px-5 lg:px-8" data-id="element-578" data-mp="1p07cadfmyskp">
          <h2 className="font-display text-[24px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[30px]" data-id="element-579" data-mp="1p20nm61720z1">
            Questions about paying for a repair?
          </h2>
          <p className="mt-4 max-w-[620px] text-[16px] leading-relaxed text-steel/75" data-id="element-580" data-mp="1f3krtpr823j7">
            Call or text the shop during business hours and The East End Team
            can walk you through the options and help you get started.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-581" data-mp="3hfxiwk7pimbu">
            <a href={business.phoneHref} className="inline-flex w-full max-w-full items-center justify-center gap-3 whitespace-normal rounded-md bg-brand px-4 py-4 text-center font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:w-auto sm:whitespace-nowrap sm:px-7" data-id="element-582" data-mp="3mfjwiurg64l6">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-583" data-mp="2yoo5hzutfdez" />
              Call {business.phone}
            </a>
            <a href={business.smsHref} className="inline-flex w-full max-w-full items-center justify-center gap-2.5 whitespace-normal rounded-md border border-ink/20 px-4 py-4 text-center text-base font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink sm:w-auto sm:whitespace-nowrap sm:px-7" data-id="element-584" data-mp="33iik4ovkd277">
              <MessageSquareIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-585" data-mp="2js6vbbyd44u0" />
              Text the shop
            </a>
          </div>

          <Link to="/specials" className="mt-8 inline-block text-[12.5px] font-bold uppercase tracking-[0.08em] text-brand-dark hover:underline" data-id="element-586" data-mp="1w6mry4ojgtnh">
            See current specials
          </Link>
        </div>
      </section>

      <TrustLocalBand data-id="element-587" data-mp="2k30kydkpa6vl" />
    </>;
}